import { Box, Button, Dialog, Typography } from "@mui/material";

export const DuplicateBudgetDialog = ({
    submit,
    open,
}: {
    open: boolean;
    submit: (duplicateEstimation: boolean) => void;
}) => {
    return (
        <Dialog
            open={open}
            sx={{
                ".MuiDialog-paper": {
                    maxWidth: "33.75rem",
                    overflowY: "unset",
                },
            }}
        >
            <Box
                sx={{
                    p: "2rem",
                    width: "100%",
                }}
            >
                <Typography
                    variant="h5"
                    sx={{
                        fontFamily: "Noto Sans",
                        fontStyle: "normal",
                        fontWeight: 400,
                    }}
                >
                    Horas Estimadas de Escopo
                </Typography>
                <Typography
                    variant="body2"
                    sx={{
                        color: "rgba(62, 55, 78, 0.87)",
                        fontFamily: "Noto Sans",
                        fontSize: "0.875rem",
                        fontStyle: "normal",
                        fontWeight: 600,
                        lineHeight: "1.125rem",
                        letterSpacing: "0.07px",
                        marginY: "1.75rem",
                    }}
                >
                    Deseja manter as horas estimadas nos itens que se mantiveram
                    dentro do escopo?
                </Typography>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "1rem",
                    }}
                >
                    <Button variant="text" onClick={() => submit(false)}>
                        Zerar Estimativas
                    </Button>
                    <Button
                        variant="outlined"
                        type="submit"
                        onClick={() => submit(true)}
                    >
                        Manter Horas
                    </Button>
                </Box>
            </Box>
        </Dialog>
    );
};
